import { SetStateAction, useEffect } from 'react';
import {
  Button,
  IcoArrowUp,
  IcoDragAndDrop,
} from '../../../../../../component';
import nls from '../../../nls/pt-BR.json';
import '../studyCreationGuide.scss';
import { ProgressBar } from './progressBar';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector';
import {
  changePositionTo,
  setCanAdvance,
  setCurrentProgressTo,
  setIsDragging,
} from '../../../redux/studies.reducer';
interface DefaultHeaderProps {
  displayChildren: boolean;
  setDisplayChildren: React.Dispatch<SetStateAction<boolean>>;
}

export const DefaultHeader: React.FC<DefaultHeaderProps> = ({
  displayChildren,
  setDisplayChildren,
}) => {
  const dispatch = useDispatch();
  const { isDragging, translatePos, currentProgress, currentStep } =
    useTypedSelector((state) => state.studies);
  const onPointerDown = (event: React.PointerEvent) => {
    event.preventDefault();
    dispatch(setIsDragging(true));
  };
  const onPointerUp = () => {
    dispatch(setIsDragging(false));
  };
  const onPointerMove = (event: React.PointerEvent | PointerEvent) => {
    if (isDragging) {
      dispatch(
        changePositionTo({
          x: translatePos.x + event.movementX,
          y: translatePos.y + event.movementY,
        })
      );
      const isdragAndDropInstructions = !currentStep.step;
      if (isdragAndDropInstructions) {
        dispatch([setCanAdvance(true), setCurrentProgressTo(1)]);
      }
    }
  };
  useEffect(() => {
    window.addEventListener('pointerup', onPointerUp);
    return () => {
      window.removeEventListener('pointerup', onPointerUp);
    };
  }, []);
  return (
    <div>
      <div className="default-header-container">
        <div className="button-and-title-container">
          <Button
            className="link normal"
            cy="StudyCreationGuidedragAndDrop"
            onPointerDown={onPointerDown}
            onPointerUp={onPointerUp}
            onPointerMove={onPointerMove}
          >
            <IcoDragAndDrop
              cy="StudyCreationGuide"
              style={{ color: '#BA96D9' }}
            />
          </Button>
          <h6 style={{ fontSize: '18px' }}>{nls.studyCreationGuide.title}</h6>
        </div>
        <Button
          className={`link normal display-children ${
            displayChildren ? 'open' : 'closed'
          }`}
          cy="StudyCreationGuideDisplayChildren"
          onClick={() => setDisplayChildren(!displayChildren)}
        >
          <IcoArrowUp cy="SetDisplayChildren" />
        </Button>
      </div>
      <ProgressBar currentValue={currentProgress} maxValue={7} />
    </div>
  );
};
